// src/ClientsPage.jsx
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const Clients = () => {
  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState('');
  const [clientDescription, setClientDescription] = useState('Submit your film with details like title, director, and film description.');
  const [clientStatus, setClientStatus] = useState(''); // New state for status
  const [isOpen, setIsOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    const defaultClients = [
      { name: 'Client A', description: 'Submit your film with details like title, director, and film description.', status: 'Accept' },
      { name: 'Client B', description: 'Submit your film with details like title, director, and film description.', status: 'Decline' },
      { name: 'Client C', description: 'Submit your film with details like title, director, and film description.', status: 'Accept' },
    ];

    const storedClients = JSON.parse(localStorage.getItem('clients')) || defaultClients;
    setClients(storedClients);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const newClient = {
      name: clientName,
      description: clientDescription,
      status: clientStatus, // Include status
    };

    if (editIndex !== null) {
      const updatedClients = clients.map((client, index) =>
        index === editIndex ? newClient : client
      );
      localStorage.setItem('clients', JSON.stringify(updatedClients));
      setClients(updatedClients);
      setEditIndex(null);
    } else {
      const updatedClients = [...clients, newClient];
      localStorage.setItem('clients', JSON.stringify(updatedClients));
      setClients(updatedClients);
    }

    // Reset form fields and close modal
    setClientName('');
    setClientDescription('Submit your film with details like title, director, and film description.');
    setClientStatus('');
    setIsOpen(false);
  };

  const handleStatusChange = (index, status) => {
    const updatedClients = clients.map((client, i) =>
      i === index ? { ...client, status } : client
    );
    localStorage.setItem('clients', JSON.stringify(updatedClients));
    setClients(updatedClients);
  };
  

  const handleEdit = (index) => {
    const clientToEdit = clients[index];
    setClientName(clientToEdit.name);
    setClientDescription(clientToEdit.description);
    setClientStatus(clientToEdit.status); // Set status for editing
    setEditIndex(index);
    setIsOpen(true);
  };

  const handleDelete = (index) => {
    const updatedClients = clients.filter((_, i) => i !== index);
    localStorage.setItem('clients', JSON.stringify(updatedClients));
    setClients(updatedClients);
  };

  return (
    <>
      <SEO
        title="Client Management"
        description="Manage your film production clients with ProducerBuddy's client management tool."
        url="https://producerbuddy.pilomation.com/clients"
        robots="noindex, nofollow"
      />
      <SubNav />
      <div className='flex gap-3'>
        {/* Sidebar */}
        <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
          <h1 className="text-2xl p-2 font-bold"><Link to='/marketing-agencies'>Marketing Dashboard</Link></h1>
          <nav>
            <ul className="space-y-4 mt-4">
              <li className="hover:text-yellow-400"><Link to='/marketing-tracker'>Campaign Management</Link></li>
              <li className="hover:text-yellow-400"><Link to='/marketing-collaborations'>Production Collabs</Link></li>
              <li className="hover:text-yellow-400"><Link to='/market-analysis'>Analytics</Link></li>
              <li className="hover:text-yellow-400"><Link to='/clients'>Clients</Link></li>
            </ul>
          </nav>
        </div>

        <div className="bg-gray-100 p-6 w-full">
          {/* Company Introduction */}
          <section className="flex justify-between mb-12 text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontSize: '24px' }}>Clients</h1>
            <div className="text-center mb-6">
              <button
                className="inline-block bg-green-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-700 transition duration-300"
              >
                Notifications
              </button>
            </div>
          </section>
          {/* Clients Section */}
          <section className="mb-12 mt-4">
            {/*<div className="text-center mb-6">
              <button
                onClick={() => setIsOpen(true)}
                className="inline-block bg-green-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-700 transition duration-300"
              >
                Add New Client
              </button>
            </div>*/}
            <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
              <table className="min-w-full border-collapse">
                <thead>
                  <tr>
                    <th className="border-b py-2 px-4 text-left">Client Name</th>
                    <th className="border-b py-2 px-4 text-left">Details</th>
                    <th className="border-b py-2 px-4 text-left">Status</th>
                    <th className="border-b py-2 px-4 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.map((client, index) => (
                    <tr key={index} className="border-b">
                      <td className="py-2 px-4">{client.name}</td>
                      <td className="py-2 px-4">{client.description}</td>
                      <td className="py-2 px-4">
                        {/* Dropdown for changing status */}
                        <select
                          value={client.status} // Display current status
                          onChange={(e) => handleStatusChange(index, e.target.value)} // Handle status change
                          className="p-2 border border-gray-300 rounded-lg w-max"
                        >
                          <option value="Accept">Accept</option>
                          <option value="Decline">Decline</option>
                        </select>
                      </td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => handleEdit(index)}
                          className="text-blue-700 hover:text-blue-800 mr-2"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(index)}
                          className="text-red-600 hover:text-red-800"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </section>

          {/* Modal for Add/Edit Client */}
          <Modal open={isOpen} onClose={() => setIsOpen(false)} center>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">{editIndex !== null ? 'Edit Client' : 'Add New Client'}</h2>
            <form onSubmit={handleSubmit} className="flex flex-col">
              <div className="mb-4">
                <label className="block text-gray-700 mb-2" htmlFor="clientName">
                  Client Name
                </label>
                <input
                  type="text"
                  id="clientName"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                  required
                  className="w-full p-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-2" htmlFor="clientDescription">
                  Client Description
                </label>
                <textarea
                  id="clientDescription"
                  value={clientDescription}
                  onChange={(e) => setClientDescription(e.target.value)}
                  required
                  rows="4"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-2" htmlFor="clientStatus">
                  Status
                </label>
                <select
                  id="clientStatus"
                  value={clientStatus}
                  onChange={(e) => setClientStatus(e.target.value)}
                  required
                  className="w-full p-2 border border-gray-500 rounded-lg"
                >
                  <option value="">Select Status</option>
                  <option value="Accept">Accept</option>
                  <option value="Decline">Decline</option>
                </select>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300"
              >
                {editIndex !== null ? 'Update Client' : 'Add Client'}
              </button>
            </form>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Clients;

